import dotenv from 'dotenv';
dotenv.config();

declare global {
  interface Window {
    NODE_ENV: string;
    API_URL: string;
  }
}

// const SERVER_URL = window.NODE_ENV === 'production' ? window.API_URL : process.env.REACT_APP_SERVER_URL;

export default {
  SERVER_URL: window.API_URL,
};
